module.exports = __webpack_public_path__ + "media/assets/icons/doubleCaretDown-fe44a819eac54dec0f269ef778209c15.svg";